"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _scss = require("@scss");

var _Link = _interopRequireDefault(require("Link"));

var _Collapse = _interopRequireDefault(require("@components/Collapse"));

var _Dropdown = _interopRequireDefault(require("@components/Layout/LegacyHeader/Dropdown"));

var _stylesModule = _interopRequireDefault(require("./../styles.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Navigation = /*#__PURE__*/(0, _react.memo)(function Navigation(_ref) {
  var _items$items;

  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? {
    align: 'center',
    items: []
  } : _ref$items,
      panelIndex = _ref.panelIndex,
      menuOnMouseEnter = _ref.menuOnMouseEnter,
      menuOnMouseOut = _ref.menuOnMouseOut,
      menuOnClick = _ref.menuOnClick,
      openPanel = _ref.openPanel,
      classes = _ref.classes;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    "data-navigation": panelIndex,
    className: (0, _scss.cls)(_stylesModule["default"]['navbar-content-bar'], (items === null || items === void 0 ? void 0 : items.align) && _stylesModule["default"][items.align], classes === null || classes === void 0 ? void 0 : classes.wrapper)
  }, items === null || items === void 0 ? void 0 : (_items$items = items.items) === null || _items$items === void 0 ? void 0 : _items$items.map(function (subitem, subItemIndex) {
    var _subitem$items;

    return /*#__PURE__*/_react["default"].createElement("li", {
      key: subItemIndex,
      "data-panel": panelIndex,
      "data-item": subItemIndex,
      onMouseEnter: menuOnMouseEnter,
      onClick: menuOnMouseEnter,
      className: (0, _scss.cls)(subitem.items && subitem.items.length > 0 ? _stylesModule["default"]['has-child'] : null, openPanel.panel === panelIndex && openPanel.item === subItemIndex ? _stylesModule["default"]['opened'] : null, classes === null || classes === void 0 ? void 0 : classes.menuListItem)
    }, subitem !== null && subitem !== void 0 && subitem.href ? /*#__PURE__*/_react["default"].createElement(_Link["default"], _extends({}, subitem, !!menuOnClick && {
      onClick: function onClick(e) {
        return menuOnClick(e, subitem === null || subitem === void 0 ? void 0 : subitem.href);
      }
    }, {
      classes: {
        root: (0, _scss.cls)(classes === null || classes === void 0 ? void 0 : classes.menuItem, subitem.className),
        active: (0, _scss.cls)(subitem.active && _stylesModule["default"]['active'])
      }
    }), subitem.title) : /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _scss.cls)(_stylesModule["default"]['no-pointer-events'], classes === null || classes === void 0 ? void 0 : classes.menuItem, subitem.className, subitem.active && _stylesModule["default"]['active'])
    }, subitem.title), subitem !== null && subitem !== void 0 && subitem.items && ((_subitem$items = subitem.items) === null || _subitem$items === void 0 ? void 0 : _subitem$items.length) > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
      onMouseLeave: menuOnMouseOut,
      className: (0, _scss.cls)(_stylesModule["default"]['submenu'])
    }, /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      isOpened: Boolean(openPanel.panel === panelIndex && openPanel.item === subItemIndex)
    }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
      items: subitem.items,
      menuOnClick: menuOnClick,
      classes: {
        submenuItem: (0, _scss.cls)(classes === null || classes === void 0 ? void 0 : classes.submenuItem)
      }
    }))) : null);
  }));
});
var _default = Navigation;
exports["default"] = _default;